if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.variantIdInput.disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')
        this.submitButtonText = this.submitButton.querySelector('span')

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog')

        this.hideErrors = this.dataset.hideErrors === 'true'
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              })
              this.handleErrorMessage(response.description)

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message')
              if (!soldOutMessage) return
              this.submitButton.setAttribute('aria-disabled', true)
              this.submitButtonText.classList.add('hidden')
              soldOutMessage.classList.remove('hidden')
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            const startMarker = CartPerformance.createStartingMarker(
              'add:wait-for-subscribers'
            )
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                )
              })
            this.error = false
            const quickAddModal = this.closest('quick-add-modal')
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(response)
                      }
                    )
                  })
                },
                { once: true }
              )
              quickAddModal.hide(true)
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response)
              })
            }
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty')
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            this.querySelector('.loading__spinner').classList.add('hidden')

            if (this._originalSubmitButton) {
              this.submitButton = this._originalSubmitButton
              this.submitButtonText = this.submitButton.querySelector('span')
              this._originalSubmitButton = null
            }

            CartPerformance.measureFromEvent('add:user-action', evt)
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled')
          if (text) this.submitButtonText.textContent = text
        } else {
          this.submitButton.removeAttribute('disabled')
          this.submitButtonText.textContent = window.variantStrings.addToCart
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]')
      }
    }
  )
}

const BaseProductForm = customElements.get('product-form')

if (BaseProductForm && !customElements.get('product-form-subscription')) {
  customElements.define(
    'product-form-subscription',
    class ProductFormSubscription extends BaseProductForm {
      constructor() {
        super()
      }

      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback()

        requestAnimationFrame(() => {
          if (!this.form) this.form = this.querySelector('form')
          if (!this.form) return

          const actualFormId = this.form.getAttribute('id')
          this.subscribeButton = document.querySelector(
            `.js-subscribe-btn[data-form-id="${actualFormId}"]`
          )
          this.subscribeQtyInput = this.subscribeButton
            ?.closest('.subscribe-wrapper')
            ?.querySelector('.js-subscribe-quantity')

          this.mainSubmitButton =
            this.querySelector('button[name="add"]') ||
            this.querySelector('[type="submit"]')

          if (this.subscribeButton) {
            this.subscribeButton.addEventListener(
              'click',
              this.onSubscribeHandler.bind(this)
            )
          }

          const originalFetch = this._patchedFetch
          if (!originalFetch) {
            this._patchedFetch = true
            const self = this
            const originalFinally = Promise.prototype.finally
          }
        })
      }

      onSubscribeHandler(evt) {
        evt.preventDefault()

        if (
          this.submitButton?.getAttribute('aria-disabled') === 'true' ||
          this.subscribeButton.hasAttribute('disabled')
        ) {
          return
        }

        const actualFormId = this.form.getAttribute('id')

        if (this.subscribeQtyInput) {
          const mainQtyInput = document.querySelector(
            `input[name="quantity"][form="${actualFormId}"]`
          )
          if (mainQtyInput) {
            mainQtyInput.value = this.subscribeQtyInput.value
          }
        }

        const sellingPlanId = this.subscribeButton.dataset.sellingPlanId
        let planInput = this.form.querySelector('input[name="selling_plan"]')

        if (!planInput) {
          planInput = document.createElement('input')
          planInput.type = 'hidden'
          planInput.name = 'selling_plan'
          this.form.appendChild(planInput)
        }
        planInput.value = sellingPlanId

        this._originalSubmitButton = this.submitButton
        this.submitButton = this.subscribeButton
        this.submitButtonText = this.subscribeButton.querySelector('span')
        this._isSubscribeAction = true

        super.onSubmitHandler(evt)

        setTimeout(() => {
          if (planInput) planInput.remove()
        }, 500)
      }
    }
  )
}
